.video {
    max-width: 100%;
}
